export default __webpack_public_path__ + "static/media/IconDesc_Geyser_128.256.9b35c651.png";